import { Flex } from '@backstage/ui';
import { EntityLayout } from './entity-layout';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { appTranslationRef } from '../../../core/i18n';
import { EntityWarningContent, UserProfileCard, OwnershipCard } from '../components';

export const UserEntityLayout = () => {
  const { t } = useTranslationRef(appTranslationRef);

  return (
    <EntityLayout>
      <EntityLayout.Route path="/" title={t('entity.tabs.overview')}>
        <Flex direction="column" gap="3">
          <EntityWarningContent />
          <UserProfileCard />
          <OwnershipCard />
        </Flex>
      </EntityLayout.Route>
    </EntityLayout>
  );
};
